// @ts-nocheck
import { createAction } from '@reduxjs/toolkit';

export const fetchOrderColumns = createAction('orderBySku/fetch-columns', function prepare({ tableId }) {
	return { payload: { tableId } };
});

export const fetchOrderData = createAction(
	'orderBySku/fetch-order-data',
	function prepare({ tableId, orderStatusValue, refreshKey }) {
		return { payload: { tableId, orderStatusValue, refreshKey } };
	}
);

export const fetchSkuAvailability = createAction('orderBySku/fetch-sku-availability', function prepare({ skuId }) {
	return { payload: { skuId } };
});
